/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_AdminInputs */

const th_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอนโซลผู้ดูแลระบบ`)
};

const en_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin console`)
};

const ja_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理コンソール`)
};

const zh_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理控制台`)
};

const es_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consola de administración`)
};

const pt_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console de administração`)
};

const id_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsol admin`)
};

const fr_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console d’administration`)
};

const tl_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin console`)
};

const vi_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng quản trị`)
};

const ko_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리자 콘솔`)
};

const de_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Konsole`)
};

const ru_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Консоль администратора`)
};

const tr_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönetim konsolu`)
};

const it_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console di amministrazione`)
};

const pl_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsola administratora`)
};

const uk_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Консоль адміністратора`)
};

const hi_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यवस्थापक कंसोल`)
};

const ar_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة الإدارة`)
};

const ms_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsol pentadbir`)
};

const bn_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রশাসন কনসোল`)
};

const zh_tw2_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理主控台`)
};

const zh_hk2_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理控制台`)
};

const ur_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظامی کنسول`)
};

const fa_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کنسول مدیریت`)
};

const sw_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kituo cha usimamizi`)
};

const nl_home_admin = /** @type {(inputs: Home_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheerconsole`)
};

/**
* | output |
* | --- |
* | "Admin console" |
*
* @param {Home_AdminInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_admin = /** @type {((inputs?: Home_AdminInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_AdminInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_admin(inputs)
	if (locale === "ja") return ja_home_admin(inputs)
	if (locale === "zh") return zh_home_admin(inputs)
	if (locale === "es") return es_home_admin(inputs)
	if (locale === "pt") return pt_home_admin(inputs)
	if (locale === "id") return id_home_admin(inputs)
	if (locale === "fr") return fr_home_admin(inputs)
	if (locale === "tl") return tl_home_admin(inputs)
	if (locale === "vi") return vi_home_admin(inputs)
	if (locale === "ko") return ko_home_admin(inputs)
	if (locale === "de") return de_home_admin(inputs)
	if (locale === "ru") return ru_home_admin(inputs)
	if (locale === "tr") return tr_home_admin(inputs)
	if (locale === "it") return it_home_admin(inputs)
	if (locale === "pl") return pl_home_admin(inputs)
	if (locale === "uk") return uk_home_admin(inputs)
	if (locale === "hi") return hi_home_admin(inputs)
	if (locale === "ar") return ar_home_admin(inputs)
	if (locale === "ms") return ms_home_admin(inputs)
	if (locale === "bn") return bn_home_admin(inputs)
	if (locale === "zh-TW") return zh_tw2_home_admin(inputs)
	if (locale === "zh-HK") return zh_hk2_home_admin(inputs)
	if (locale === "ur") return ur_home_admin(inputs)
	if (locale === "fa") return fa_home_admin(inputs)
	if (locale === "sw") return sw_home_admin(inputs)
	if (locale === "nl") return nl_home_admin(inputs)
	return en_home_admin(inputs)
});